<template>
    <Tooltip :is-disabled="props.allocationCount.total === 0">
        <template #trigger="tooltipProps">
            <p
                :id="props.id"
                class="focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:z-40 focus-visible:outline-gray-700 rounded-xs"
                :class="{ 'cursor-help font-bold': props.allocationCount.total > 0 }"
                :aria-describedby="props.allocationCount.total === 0 ? undefined : tooltipProps['aria-labelledby']"
                :popovertarget="props.allocationCount.total === 0 ? undefined : tooltipProps.popovertarget"
                :tabindex="props.allocationCount.total === 0 ? undefined : 0"
            >
                {{ props.label }}

                <span v-if="props.allocationCount.total > 0" class="font-light" :class="[props.countTextColorClass]">
                    <template v-if="props.allocationCount.inRange === props.allocationCount.total">
                        ({{ props.allocationCount.total }})
                    </template>

                    <template v-if="props.allocationCount.inRange !== props.allocationCount.total">
                        ({{ props.allocationCount.inRange }}/{{ props.allocationCount.total }})
                    </template>
                </span>
            </p>
        </template>

        <template #text>
            <i18n
                v-if="props.allocationCount.inRange === props.allocationCount.total"
                path="location-contains-all-allocations"
                :args="{ count: props.allocationCount.total }"
            >
                <template #allocationCount>
                    <span class="font-semibold">
                        {{ props.allocationCount.total }}
                    </span>
                </template>
            </i18n>

            <i18n
                v-if="props.allocationCount.inRange !== props.allocationCount.total"
                path="location-contains-allocations"
                :args="{ count: props.allocationCount.inRange }"
            >
                <template #inRangeAllocationCount>
                    <span class="font-semibold">
                        {{ props.allocationCount.inRange }}
                    </span>
                </template>

                <template #totalAllocationCount>
                    <span class="font-semibold">
                        {{ props.allocationCount.total }}
                    </span>
                </template>
            </i18n>
        </template>
    </Tooltip>
</template>

<script setup lang="ts">
import Tooltip from '@/components/Tooltip/Tooltip.vue';
import type { AllocationCount } from '../logic/allocationCounts';

type LocationAllocationCountLabelProps = {
    id: string;
    label: string;
    allocationCount: AllocationCount;
    countTextColorClass: string;
};

const props = defineProps<LocationAllocationCountLabelProps>();
</script>
